export const DAY_SHORT = ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"];

const toMin = (t) => {
  const [h, m] = t.split(":").map(Number);
  return h * 60 + m;
};
const fmt = (m) => `${String(Math.floor(m / 60)).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`;
const structured = (rows = []) => rows.filter((r) => r.weekdays?.length && r.open && r.close && r.open < r.close);

export function scheduleFor(settings, catId) {
  const svc = (catId && settings.service_schedules?.[catId]) || {};
  const rows = svc.hours?.length ? structured(svc.hours) : structured(settings.operating_hours);
  return { rows, interval: svc.interval || settings.slot_interval || 60 };
}

export const dayHasHours = (sched, date) => sched.rows.some((r) => r.weekdays.includes(date.getDay()));

export function slotsFor(sched, date) {
  if (!date) return [];
  const out = new Set();
  sched.rows.filter((r) => r.weekdays.includes(date.getDay())).forEach((r) => {
    for (let m = toMin(r.open); m + sched.interval <= toMin(r.close); m += sched.interval) out.add(fmt(m));
  });
  const now = new Date();
  const isToday = date.toDateString() === now.toDateString();
  const nowMin = now.getHours() * 60 + now.getMinutes();
  return [...out].sort().filter((s) => !isToday || toMin(s) > nowMin);
}
